<template>
  <font-awesome-icon size="lg" :icon="['fas', icon]" />
</template>
<script>
export default {
  props: ["icon"],
};
</script>